import { useState } from "react";
import { IShift } from '../../Types/models';
import { useAuthContext } from "../../contexts/AuthContext";
import UserImage from "../UserImage";
import useShiftService from "../../pages/services/ShiftService";
import { AgendaShift, AgendaUser } from "../../graphql/API";
import useDateService from "../../pages/services/DateService";
import useHelperService from '../../pages/services/HelperService';
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate} from "react-router-dom";
import useShiftApplicationService from "../../pages/services/ShiftApplicationService";
import CustomModal from "../Modals/CustomModal";
import { format, formatDistanceToNow } from "date-fns";
import Cookies from "js-cookie";
import { enUS, fr } from 'date-fns/locale';
import { IoArrowRedoCircleOutline } from "react-icons/io5";


interface IShiftProps {
    shift: IShift;
    lastStartAt: Date;
    index: number;
    includedDetails?: boolean;
    isNew?: boolean;
    locale: string;
    conflicted?: boolean;
    user: AgendaUser;
    nav: string;
    managers?: AgendaUser[];
};

const ShiftManager = ({shift, lastStartAt, index, includedDetails = false, isNew = false, locale = "en", conflicted, user, nav, managers}: IShiftProps) => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    // const savedLang = Cookies.get('language');
    // const [locale, setLocale] = useState("en");
    // NAVIGATION
    const navigate = useNavigate();
    // SERVICES
    const {truncate} = useHelperService();
    const {onUpdateShiftConfirm, onUpdateShiftUnConfirm, onDeleteShift} = useShiftService(
        shift as unknown as AgendaShift, user?.type == "MANAGER" && true, locale, shift?.startAt?.split("T")[0], nav, managers);
    // BUTTONS
    const [loadingButton, setLoadingButton] = useState(false);
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [footerModal, setFooterModal] = useState(true);

    const {getTIMEZONE, getDateTimeWithTimezone, isNowGreater} = useDateService();
    const TIMEZONE = getTIMEZONE();

    const getLanguage = () => {
        switch (locale) {
            case 'en':
            return enUS
            case 'fr':
            return fr
            default:
            return enUS
        }
    }

    const theDay = new Date(shift.startAt);
    const eventDay = format(new Date(theDay).setHours(theDay.getHours() - TIMEZONE), "yyyy-MM-dd", {locale: getLanguage()}); // Formater la date du jour
    const eventStarAt =  new Date(lastStartAt);//events[index === 0 ? 0 : index - 1].startAt);
    eventStarAt.setHours(eventStarAt.getHours() - TIMEZONE);
    const startAt = new Date(shift.startAt);
    startAt.setHours(startAt.getHours() - TIMEZONE);
    const stopAt = new Date(shift.stopAt);
    stopAt.setHours(stopAt.getHours() - TIMEZONE);

    // const alreadyStarted = isNowGreater(new Date(shift.startAt), TIMEZONE);
    // const alreadyDone = isNowGreater(new Date(shift.stopAt), TIMEZONE);

    const confirmShift = async () => {
        setShowCustomModal(false)
        if (loadingButton) return;
        setLoadingButton(true);
        await onUpdateShiftConfirm();
        setLoadingButton(false);
    }

    const unconfirmShift = async () => {
        setShowCustomModal(false)
        if (loadingButton) return;
        setLoadingButton(true);
        await onUpdateShiftUnConfirm();
        setLoadingButton(false);
    }

    const deleteShift = async () => {
        setShowCustomModal(false)
        if (loadingButton) return;
        setLoadingButton(true);
        await onDeleteShift();
        setLoadingButton(false);
    }

    const confirmOnShift = () => {
        setFooterModal(false);
        setContentModal(<>
          <Modal.Header closeButton>
            <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
              </Modal.Header>
        
              <Modal.Body>
                <p>{t('shift.confirmedMessage')}</p></Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                  {t('shift.cancel')}
                </Button>
                <Button variant="primary" onClick={ () => confirmShift()}>
                  {t('shift.confirm')}
                </Button>
              </Modal.Footer>
          </>);
        setShowCustomModal(true);
    }
    
    const unconfirmOnShift = () => {
        setFooterModal(false);
        setContentModal(<>
          <Modal.Header closeButton>
            <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
              </Modal.Header>
        
              <Modal.Body>
                <p>{t('shift.unconfirmedMessage')}</p></Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                  {t('shift.cancel')}
                </Button>
                <Button variant="primary" onClick={ () => unconfirmShift()}>
                  {t('shift.confirm')}
                </Button>
              </Modal.Footer>
          </>);
        setShowCustomModal(true);
    }

    const deleteOnShift = (item: any) => {
        setFooterModal(false);
        setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
          </Modal.Header>         
    
          <Modal.Body>
            <p>{t('shift.deletedMessage')}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}  
            </Button>
            <Button variant="danger" onClick={() => deleteShift()}>
              {t('shift.delete')}
            </Button>
          </Modal.Footer></>);
        // setLinkModal('/shifts');
        setShowCustomModal(true);
    }

    const goToShift = () => {
        navigate(`${t('link.shift')}/${shift.shiftId}`);
    }

    const getInfo = (title: string, body: string) => {
        setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{body}</p>
          </Modal.Body></>);
        setShowCustomModal(true);
    }

    const fromNow = (startAt: string, stopAt: string) => {
        const alreadyStarted = isNowGreater(new Date(startAt), TIMEZONE);
        const alreadyDone = isNowGreater(new Date(stopAt), TIMEZONE);
        return formatDistanceToNow(new Date(
            alreadyStarted && alreadyDone ? stopAt : startAt), 
            { addSuffix: true, locale: getLanguage()});
        
            // new Date(date), { addSuffix: true, locale: getLanguage()});
    };

    return (
        <>
            <CustomModal
                show={showCustomModal}
                onHide={() => setShowCustomModal(false)}
                link={linkModal}
                children={contentModal}
                isFooter={footerModal}
                // animation={true}
            />
            <div data-date={eventDay} className="mb-3">
                {index === 0 || format(eventStarAt, "yyyy-MM-dd", { locale: getLanguage() }) !== eventDay ? (
                <h4 className="mb-3">{format(startAt, "EEEE d MMMM", { locale: getLanguage() })}</h4>
                ) : null}

                <div className="p-3 bg-light border rounded-4 shadow-sm">
                <div className="row align-items-start g-3">
                    {/* User info */}
                    <div className="col-md-4 col-12">
                    <div className="text-center p-3 flex-column d-flex h-100">
                        <Link to={`${t('link.user')}/${shift.userId}`} className="fw-bold d-block">{shift.username}</Link>

                        {shift.accepted ? (
                        <span className="text-success" style={{paddingBottom:2}}>{t('shift.accepted')}</span>
                        ) : (
                        <span className="text-danger" style={{paddingBottom:2}}>{t('shift.notAccepted')}</span>
                        )}
                        { shift.confirmed ? (
                        // <span className="text-success mb-4">{t('shift.confirmed')}</span>
                        <Button variant="danger" onClick={() => unconfirmOnShift()} className="mb-2">{t('shift.unconfirm')}</Button>    
                        
                        ) : (
                        <Button variant="success" onClick={() => confirmOnShift()} className="mb-2">{t('shift.confirm')}</Button>    
                        )}
                        <Button variant="danger" onClick={() => deleteOnShift(shift)} className="mt-auto">{t('shift.delete')}</Button>
                    </div>
                    </div>
                    {/* Left info */}
                    <div className="col-md-4 col-12">
                    <div className="bg-white border rounded-4 p-3 h-100">
                        <div className="mb-2">
                        <strong>{shift.role}</strong><br />
                        <span>{shift.location}</span>
                        </div>
                        <div className="mb-2">
                        {format(startAt, "HH:mm", { locale: getLanguage() })} - {format(stopAt, "HH:mm", { locale: getLanguage() })}
                        </div>
                        <Button className="w-100 mt-2" onClick={() => getInfo(t('agenda.infoTitle'), shift.info)}>
                        {t('agenda.info')}
                        </Button>
                    </div>
                    </div>

                    

                    {/* Icon navigation */}
                    <div className="col-md-4 col-12 text-center d-flex flex-column align-items-center justify-content-center align-self-center">
                    <IoArrowRedoCircleOutline
                        onClick={() => goToShift()}
                        className="hover-icon"
                        size={80}
                        style={{ cursor: 'pointer', justifySelf: 'center' }}
                    />
                    <span className="text-muted">{fromNow(startAt.toString(), stopAt.toString())}</span>
                    </div>
                </div>
                </div>
            </div>
            {/* <div data-date={eventDay}>
            {index === 0 || format(eventStarAt, "yyyy-MM-dd", {locale: getLanguage()}) !== eventDay ? (
                <h3>{format(startAt, "EEEE d MMMM", {locale: getLanguage()})}</h3>
            ) : null}
            </div>
            <div key={'shift_' + event.shiftId} className="p-2 flex-fill bg-light border rounded-4" >
                <Stack direction="horizontal" gap={3} className="align-items-start">
                <div className="flex-grow-2 p-2 bg-white border rounded-4" style={{maxWidth: 200}}>
                    <Link to={`${t('link.user')}/${event.userId}`} className="text-decoration-none text-dark fw-bold link">
                        <UserImage user={(event as any).user} customClass="coworker_sm shadow-sm hover:shadow-md" key={"worker_" + event?.userId + event.shiftId} />
                    </Link>
                    <Button variant="info" onClick={() => getInfo(t('agenda.infoTitle'), event.info)}>{t('agenda.info')}</Button><br />
                    <span>{fromNow(startAt.toString())}</span><br />
                    
                </div>
                <div className="flex-grow-1 p-2">
                    <Stack direction="vertical" gap={3} className="align-items-start">
                    <div className="flex-grow-1 text-start">
                        <Link to={`${t('link.user')}/${event.userId}`}>
                        <strong style={{wordBreak: 'break-word'}}>{event.username}</strong>
                        </Link> <br />
                        <span>{event.role}</span><br />
                        <span>{event.location}</span><br />
                        <div className="flex-grow-1">
                            {format(startAt, "HH:mm", {locale: getLanguage()})} to {format(stopAt, "HH:mm", {locale: getLanguage()})}
                        </div>
                    </div>
                    </Stack>
                </div>
                <div className="flex-grow-2 p-2">
                    <IoArrowRedoCircleOutline onClick={() => goToShift(event.shiftId)} className="hover-icon" size={80}/>
                </div>
                </Stack>
            </div>  */}
            </>
    );
};

export default ShiftManager;